<template>
    <v-container fill-height class="py-0">
        <v-row justify="center" align="center">
            <v-col cols="12" xl="4" lg="5" md="6">
                <v-img class="mx-auto ml-md-0" src="/images/neumann-logo.png" width="250"></v-img>
                <p class="mt-6 mb-0 subtitle text-center text-md-left">Aprende un nuevo idioma de una manera fácil, cómoda y divertida.</p>
            </v-col>
            <v-col cols="12" xl="3" lg="6" md="6">
                <v-card>
                    <v-card-text>
                        <v-form ref="register" v-on:submit.prevent="submit">
                            <v-text-field
                                v-model="names"
                                :rules="[rules.required]"
                                placeholder="Nombre(s)"
                                outlined
                            >
                            </v-text-field>
                            <v-text-field
                                v-model="paternal_surname"
                                :rules="[rules.required]"
                                placeholder="Apellido paterno"
                                outlined
                            >
                            </v-text-field>
                            <v-text-field
                                v-model="maternal_surname"
                                :rules="[rules.required]"
                                placeholder="Apellido materno"
                                outlined
                            >
                            </v-text-field>
                            <vue-tel-input-vuetify
                                placeholder="Whatsapp"
                                @input="onInput"
                                :rules="[rules.required, rules.phone]"
                                :onlyCountries="['mx', 'co', 'uy', 'pe', 'cl', 'ar']"
                                :required="true"
                                label=""
                                @country-changed="updateCountry"
                                outlined
                            ></vue-tel-input-vuetify>
                            <!-- <v-text-field
                                v-model="phone"
                                :rules="[rules.required, rules.phone]"
                                placeholder="Whatsapp"
                                outlined
                            >
                            </v-text-field> -->
                            <v-text-field
                                type="email"
                                @keydown.space.prevent
                                v-model="email"
                                :rules="[rules.required, rules.email]"
                                color="#008DD4"
                                name="email"
                                outlined
                                placeholder="Correo electrónico"
                            ></v-text-field>
                            <v-subheader>Establece una contraseña nueva.</v-subheader>
                            <v-text-field
                                :type="show_password ? 'text' : 'password'"
                                :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                                v-model="password"
                                :rules="[rules.required]"
                                color="#008DD4"
                                name="password"
                                outlined
                                placeholder="Contraseña"
                                hint="Recuerda anotar tu nueva contraseña"
                                @click:append="show_password = !show_password"
                            ></v-text-field>
                            <v-row>
                                <v-alert dense type="error">
                                    Es importante que tu correo y teléfono sean correctos para poder entrar a tus clases.
                                </v-alert>
                            </v-row>
                            <v-row class="py-0 my-0" no-gutters>
                                <v-spacer></v-spacer>
                                <v-checkbox color="#008DD4" :rules="[rules.required]" class="my-0">
                                    <template v-slot:label>
                                        <div>
                                            Acepto
                                            <a @click.stop="politics = !politics">
                                                politicas de privacidad
                                            </a>
                                            y
                                            <a @click.stop="conditions = !conditions">
                                                terminos y condiciones
                                            </a>
                                        </div>
                                    </template>
                                </v-checkbox>
                            </v-row>
                            <v-btn type="submit" block color="success" x-large>Registrate</v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>

                <v-card class="mt-3">
                    <v-card-text class="py-0">
                        <v-col class="text-center">
                            <a href="/login" class="text-decoration-none">¿Ya tienes una cuenta?</a>
                        </v-col>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="politics" max-width="800" scrollable>
            <v-card>
                <v-card-title>Politicas de privacidad</v-card-title>
                <v-card-text class="text-justify">
                    <h4>INTRODUCCIÓN</h4>
                    En Instituto Neumann, nos comprometemos a proteger la privacidad de nuestros estudiantes y usuarios. Esta Política de Privacidad explica cómo recopilamos, usamos, revelamos y salvaguardamos tu información cuando utilizas nuestro sitio web y nuestros servicios.

                    <br/><br/>
                    <h4>RECOLECCIÓN DE INFORMACIÓN</h4>
                    Recopilamos información personal que nos proporcionas voluntariamente cuando te registras en nuestro sitio web o expresas interés en obtener información sobre nosotros o nuestros servicios. Los datos personales que recopilamos pueden incluir tu nombre, dirección de correo electrónico, número de teléfono y otros datos de contacto.

                    <br/><br/>
                    <h4>USO DE LA INFORMACIÓN</h4>
                    Utilizamos la información que recopilamos exclusivamente para proporcionarte nuestros servicios, procesar tus pagos, enviar actualizaciones y responder a tus consultas. No compartimos tu información personal con terceros no afiliados sin tu consentimiento, excepto en circunstancias específicas donde sea necesario para proporcionarte nuestros servicios.

                    <br/><br/>
                    <h4>PROTECCIÓN DE TU INFORMACIÓN</h4>
                    Valoramos tu información y nos esforzamos en protegerla al máximo posible utilizando medidas técnicas y organizativas. Sin embargo, ninguna transmisión de datos a través de Internet o almacenamiento de información digital puede garantizar ser 100% segura. Por lo tanto, a pesar de nuestros esfuerzos por proteger tu información personal, Instituto Neumann no puede asegurar ni garantizar la seguridad de ninguna información que transmitas o compartas con nosotros. No asumimos responsabilidad por el acceso no autorizado, uso o divulgación de tu información personal.

                    <br/><br/>
                    <h4>INFORMACIÓN DE PAGO</h4>
                    Todos los pagos realizados a través de nuestra plataforma son procesados por plataformas de pago externas. Esto significa que no almacenamos ni tenemos acceso a información de tarjetas de crédito, cuentas bancarias u otra información de pago. Al realizar un pago, serás sujeto a las políticas de privacidad y términos y condiciones de la plataforma de pago externa. No nos hacemos responsables de la seguridad o privacidad de la información que proporcionas a estas plataformas de pago externas.

                    <br/><br/>
                    <h4>ACCESO A TU INFORMACIÓN</h4>
                    Tienes derecho a acceder a la información personal que tenemos sobre ti y a solicitar que corrijamos, actualicemos o eliminemos tu información personal. Para hacerlo, puedes ponerte en contacto con nosotros en [correo de contacto].

                    <br/><br/>
                    <h4>ACTUALIZACIONES DE LA POLÍTICA DE PRIVACIDAD</h4>
                    Podemos actualizar esta Política de Privacidad de vez en cuando. Si hacemos cambios materiales en la forma en que tratamos la información personal de nuestros usuarios, te notificaremos publicando la nueva política de privacidad en nuestro sitio web.

                    <br/><br/>
                    Al usar nuestro sitio web y nuestros servicios, aceptas las prácticas descritas en esta Política de Privacidad. Si tienes alguna pregunta sobre esta Política de Privacidad, por favor contáctanos en [correo de contacto].

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="politics = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="conditions" max-width="800" scrollable>
            <v-card>
                <v-card-title>Terminos y Condiciones</v-card-title>
                <v-card-text class="text-justify">
                    Gracias por elegir a Instituto Neumann ("la Escuela"). Los siguientes términos y condiciones rigen el uso de nuestros servicios en línea. Le recomendamos que lea estos términos y condiciones cuidadosamente antes de utilizar nuestros servicios.
                    <br/><br/>
                    <h4>1. DEFINICIONES</h4>
                    1.1 "Servicios" se refiere a las clases de idiomas en línea, y las grabaciones de las clases proporcionadas en la plataforma de la Escuela.<br/>
                    1.2 "Plataforma" se refiere al sitio web o aplicación móvil a través del cual se accede a los Servicios.

                    <br/><br/>
                    <h4>2. PROVISIÓN DE SERVICIOS</h4>
                    2.1 La Escuela proporciona los Servicios a través de Google Meet y Google Drive. <br/>
                    2.2 Los Servicios incluyen el acceso a clases de idiomas en vivo y grabadas que se pueden visualizar en la Plataforma de la Escuela durante un período de 72 horas después de la clase. Tenga en cuenta que la disponibilidad de las grabaciones puede variar, ya que depende de la capacidad de Google Meet y Google Drive para almacenar y transmitir estos videos, respectivamente.<br/>
                    2.3 La Escuela se esfuerza por abrir cursos según las fechas previstas, pero el inicio de los cursos puede depender del número de estudiantes inscritos. Las fechas son estimadas y pueden estar sujetas a cambios.

                    <br/><br/>
                    <h4>3. RESPONSABILIDAD DEL USUARIO</h4>
                    3.1 Al inscribirse en la Escuela, el usuario se compromete a proporcionar información verdadera, precisa y completa, y a mantener dicha información actualizada.<br/>
                    3.2 El usuario es responsable de asegurar que su equipo cumpla con los requisitos técnicos necesarios para acceder a los Servicios, y de obtener asistencia técnica si experimenta problemas al intentar visualizar los videos. Estos videos se almacenan en Google Drive y se integran en la Plataforma a través de un código de iframe proporcionado por Google Drive. Cualquier problema técnico relacionado con Google Drive, Google Meet, o cualquier otra plataforma de terceros, debe ser resuelto por el usuario.
                    <br/><br/>
                    <h4>4. PAGO</h4>
                    4.1 El pago por los Servicios se realizará por adelantado y una vez realizado, no podrá ser reembolsado, incluso si el usuario decide no participar en el curso, si el curso no comienza en la fecha estimada o si el horario del curso cambia.

                    <br/><br/>
                    <h4>5. COMPORTAMIENTO EN CLASE</h4>
                    5.1 Se espera que los estudiantes se comporten de manera adecuada y respetuosa en las clases. La Escuela se reserva el derecho de dar de baja a cualquier estudiante que muestre un comportamiento inapropiado, tras haber recibido una advertencia.

                    <br/><br/>
                    <h4>6. USO PERSONAL DE LAS CLASES</h4>
                    6.1 Las clases son para el uso personal del estudiante inscrito y no se permite compartir el enlace de la clase con otras personas. La violación de este término puede resultar en la suspensión del acceso a los Servicios.

                    <br/><br/>
                    <h4>7. MATERIAL DE LA CLASE</h4>
                    7.1 El material didáctico utilizado en las clases es propiedad de la Escuela y está protegido por los derechos de autor. No se permitirá el acceso o la distribución de este material fuera de las clases.

                    <br/><br/>
                    <h4>8. PROGRESO DEL ESTUDIANTE</h4>
                    8.1 Aunque la Escuela proporciona los recursos necesarios para el aprendizaje, el progreso del estudiante depende en gran medida de su compromiso personal y su participación activa en las clases.

                    <br/><br/>
                    <h4>9. COMPROMISO DEL ESTUDIANTE</h4>
                    9.1 Se espera que los estudiantes asistan a las clases a tiempo, participen activamente y, cuando sea posible, tengan sus cámaras encendidas. Si un estudiante no puede asistir a una clase, deberá revisar la grabación de la clase para mantenerse al día con el contenido.

                    <br/><br/>
                    <h4>10. COMPATIBILIDAD DE LOS SISTEMAS OPERATIVOS</h4>
                    10.1 Los usuarios necesitan un sistema que sea compatible con Google Drive. La Escuela no se hace responsable si los usuarios no pueden ver los videos debido a problemas de compatibilidad.

                    <br/><br/>
                    <h4>16. DISPONIBILIDAD DE LOS VIDEOS</h4>
                    16.1 Si, por razones ajenas al control de la Escuela, los videos de las clases no están disponibles (por ejemplo, debido a problemas de procesamiento de Google), la Escuela no se hace responsable.

                    <br/><br/>
                    <h4>17. RECOMPENSAS POR REFERENCIAS</h4>
                    17.1 La Escuela ofrece un sistema de recompensas para los estudiantes que refieran a nuevos estudiantes. Si un nuevo estudiante se inscribe en un curso utilizando el enlace de referencia de un estudiante existente, y completa el proceso de inscripción (registro, selección del curso y pago del curso), el estudiante existente recibirá un crédito de 100 [moneda] para su próximo curso.

                    <br/><br/>
                    <h4>18. CAMBIO DE PROFESORES</h4>
                    18.1 Los profesores pueden cambiar entre los cursos o durante el curso por cuestiones administrativas. La Escuela hará todo lo posible por garantizar una transición suave y mantener la calidad de la enseñanza.

                    <br/><br/>
                    <h4>19. AUSENCIA DE PROFESORES</h4>
                    19.1 En caso de que un profesor no pueda asistir a una clase, la Escuela hará todo lo posible por encontrar un profesor sustituto. Si esto no es posible, la clase se reprogramará en el mismo horario, lo que puede significar que el curso se extienda una clase más.

                    <br/><br/>
                    <h4>20. ACCESO A LA CLASE</h4>
                    20.1 El enlace para acceder a la clase estará disponible en la Plataforma. La Escuela puede proporcionar este enlace también a través de un grupo de WhatsApp, pero esto es solo un apoyo y no siempre se hará de esta manera. Los estudiantes deben acceder a la Plataforma para obtener el enlace de la clase.

                    Al inscribirse en un curso y utilizar nuestros Servicios, usted acepta estos Términos y Condiciones en su totalidad. Por favor, asegúrese de entender y estar de acuerdo con estos Términos y Condiciones antes de inscribirse.


                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="conditions = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-container>
</template>
<script>

import iziToast from 'izitoast'
import { parsePhoneNumberFromString, isValidNumber } from 'libphonenumber-js'

export default {
    props:['referred', 'is_page', 'course_id'],
    data: () => ({

        //models
        form:false,
        dialog:false,
        politics:false,
        conditions:false,

        //urls
        img:"/images/option2.png",
        store_url:"/register",

        //props
        color: "#000",
        loading:false,
        email_error_messages:"",
        name_error_messages:"",
        error_message:"",
        phone_valid:false,

        //rules
        // rules:{
        //     required: v => !!v || 'El campo es requerido',
        //     email: v => /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(v) || 'El Correo electrónico ingresado no es válido',
        //     length: v  => !!v && v.length >= 8 || 'Debe contener al menos 8 caracteres',
        //     phone: v => (!!v && this.validatePhone(v)) || 'Número de teléfono inválido',
        // },

        //form models
        names:"",
        paternal_surname:"",
        maternal_surname:"",
        email:"",
        name:"",
        password:"",
        password_confirmation:"",
        teacher:false,
        phone:"",
        institute:"",
        proof_institute:[],
        country: null,

        show_password:false
    }),
    mounted(){
        axios.get('https://ipapi.co/json/')
        .then(function(response) {
            console.log('el pais es');
            console.log(response.data);
        })
        .catch(function(error) {
            console.log(error);
        });

    },
    watch:{
        password:function(val){
            this.password_confirmation = val
        },
    },

    methods:{
        onInput(formattedNumber, { number, valid, country }) {
            this.phone = number.e164
            this.phone_valid = valid
        },
        updateCountry(country) {
            this.country = country;
        },
        submit:function(event){
            if(this.$refs.register.validate()){
                this.loading = true

                let data = new FormData();
                data.append('names', this.names)
                data.append('paternal_surname', this.paternal_surname)
                data.append('maternal_surname', this.maternal_surname)
                data.append('email', this.email)
                data.append('name', this.email)
                data.append('password', this.password)
                data.append('password_confirmation', this.password_confirmation)
                data.append('phone', this.phone)
                data.append('teacher', this.teacher ? '1' : '0')
                data.append('referred', JSON.stringify(this.referred))
                data.append('institute', this.institute)
                data.append('proof_institute', this.proof_institute)
                data.append('course_id', this.course_id)
                data.append('country_code', this.country.iso2)
                console.log('los datos de registro son')
                console.log(data)
                axios.post(this.store_url, data).then(response => {
                    this.loading = false
                    location.replace(response.data.redirect ? '/home' : '/login')
                }).catch(error => {
                    this.loading = false
                    if(error.response.data.errors){
                        for(let prop in error.response.data.errors){
                            for(let message of error.response.data.errors[prop]){
                                iziToast.error({
                                    title:"Error",
                                    position:'topRight',
                                    message: message
                                })
                            }
                        }
                    }else{
                        iziToast.error({
                            title:"Error",
                            position:'topRight',
                            message: "Ha ocurrido un error en la comunicación con el servidor, intente más tarde"
                        })
                    }
                })
            }
        }
    },

    computed: {
        rules() {
            return {
                required: v => !!v || 'El campo es requerido',
                email: v => /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/.test(v) || 'El Correo electrónico ingresado no es válido',
                length: v  => v && v.length >= 8 || 'Debe contener al menos 8 caracteres',
                phone: v => this.phone_valid || 'Número de teléfono inválido',
            };
        },
    },
}
</script>
